import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getFortnoxFinancialYears = (token: string, backend: string) => {
    return fetch(`${getApiUrl(backend)}fortnox_financial_years`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getFortnoxFinancialYears